var router = require('pjax').Router;

router.get('profile/authenticator', require('./index.js'));
